// IndeterminateCheckbox.js
import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function IndeterminateCheckbox(props) {
    const { label, checked, onChange, name, ...rest } = props;

    const handleChange = (event) => {
        if (onChange) {
            onChange(event)
        }
    };

    return (
        <FormControlLabel
            label={label}
            control={
                <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    name={name}
                    {...rest}
                />
            }
        />
    );
}
